import React, { useEffect, useState } from "react";
import { PaymentLinkDrawerType } from "enums/PaymentLink";
import { usePaymentLinkData } from "hooks/usePaymentLinkData";
import CreateEditPaymentLinkDrawer from "./CreateEditPaymentLinkDrawer";
import PaymentLinkDetailsDrawer from "./PaymentLinkDetailsDrawer";
import DeactivatePaymentLinkModal from "./DeactivatePaymentLinkModal";
import PaymentLinkPaymentsDrawer from "./PaymentLinkPaymentsDrawer";
import PaymentLinkSubscribersDrawer from "./PaymentLinkSubscribersDrawer";

interface PaymentLinkDrawerRouterProps {
  open: boolean;
  drawerType: PaymentLinkDrawerType;
  paymentLinkId?: string;
  readOnly: boolean;
  onClose: (refresh?: boolean, openDetailsWithId?: string) => void;
  /** Fires once the routed drawer has slid out. */
  onAfterClose?: () => void;
  onEdit: (paymentLinkId: string) => void;
}

const PaymentLinkDrawerRouter: React.FC<PaymentLinkDrawerRouterProps> = ({
  open,
  drawerType,
  paymentLinkId,
  readOnly,
  onClose,
  onAfterClose,
  onEdit,
}) => {
  const { paymentLink, loadPaymentLink, loading } = usePaymentLinkData();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [paymentsOpen, setPaymentsOpen] = useState(false);
  const [subscribersOpen, setSubscribersOpen] = useState(false);

  const needsExistingLink = drawerType !== PaymentLinkDrawerType.Create;

  useEffect(() => {
    if (open && needsExistingLink && paymentLinkId) {
      loadPaymentLink(paymentLinkId);
    }
  }, [open, needsExistingLink, paymentLinkId, loadPaymentLink]);

  if (drawerType === PaymentLinkDrawerType.Details) {
    return (
      <>
        <PaymentLinkDetailsDrawer
          open={open}
          paymentLink={paymentLink}
          loading={loading}
          readOnly={readOnly}
          onClose={() => onClose()}
          onAfterClose={onAfterClose}
          onEdit={onEdit}
          onToggleStatus={() => setStatusModalOpen(true)}
          onViewPayments={() => setPaymentsOpen(true)}
          onViewSubscribers={() => setSubscribersOpen(true)}
        />
        <PaymentLinkPaymentsDrawer
          open={paymentsOpen}
          paymentLinkId={paymentLink?.id || null}
          paymentLinkName={paymentLink?.name}
          onClose={() => setPaymentsOpen(false)}
        />
        <PaymentLinkSubscribersDrawer
          open={subscribersOpen}
          paymentLinkId={paymentLink?.id || null}
          paymentLinkName={paymentLink?.name}
          readOnly={readOnly}
          onClose={() => setSubscribersOpen(false)}
        />
        <DeactivatePaymentLinkModal
          open={statusModalOpen}
          paymentLink={paymentLink}
          onClose={() => setStatusModalOpen(false)}
          onDone={() => onClose(true)}
        />
      </>
    );
  }

  return (
    <CreateEditPaymentLinkDrawer
      open={open}
      paymentLink={needsExistingLink ? paymentLink : null}
      onClose={onClose}
      onAfterClose={onAfterClose}
    />
  );
};

export default PaymentLinkDrawerRouter;
